import { RefreshCcw } from 'lucide-react'
import OpacityAnimation from '@/components/animations/OpacityAnimation'
import { Button, Row } from '@/components/core'

interface DidntUnderstandButtonProps {
  onClick: () => void
}

const DidntUnderstandButton = ({ onClick }: DidntUnderstandButtonProps) => {
  return (
    <Row className="max-h-10">
      <OpacityAnimation>
        <Button.Translated
          translationKey="didnt_understand_test_testing_didnt_understand"
          size="sm"
          variant="solid"
          color="flat-primary"
          onClick={onClick}
          icon={<RefreshCcw height={16} width={16} />}
        />
      </OpacityAnimation>
    </Row>
  )
}

export default DidntUnderstandButton
